"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useManagerAppointmentCubby = exports.NewAppointmentStage = exports.ManagerAppointmentCubbyContextProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _lodash = require("lodash");
var _utils2 = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var NewAppointmentStage = /*#__PURE__*/function (NewAppointmentStage) {
  NewAppointmentStage["SelectParticipants"] = "select-participants";
  NewAppointmentStage["SelectAppointmentType"] = "select-appointment-type";
  NewAppointmentStage["SelectSingleAppointment"] = "select-single-appointment";
  NewAppointmentStage["SelectNewSingleAppointment"] = "select-new-single-appointment";
  NewAppointmentStage["SelectRecurringAppointment"] = "select-recurring-appointment";
  NewAppointmentStage["SelectNewRecurringAppointment"] = "select-new-recurring-appointment";
  NewAppointmentStage["ManageRecurring"] = "manage-recurring";
  NewAppointmentStage["Finished"] = "finished";
  return NewAppointmentStage;
}({});
exports.NewAppointmentStage = NewAppointmentStage;
var ManagerAppointmentCubbyContext = /*#__PURE__*/_react.default.createContext({});
var useManagerAppointmentCubby = function useManagerAppointmentCubby() {
  return (0, _react.useContext)(ManagerAppointmentCubbyContext);
};
exports.useManagerAppointmentCubby = useManagerAppointmentCubby;
var getInitialStage = function getInitialStage(_ref) {
  var appointment = _ref.appointment,
    targetClinician = _ref.targetClinician,
    targetPatient = _ref.targetPatient,
    recurringRule = _ref.recurringRule;
  if (appointment) {
    return appointment.recurringRuleId ? NewAppointmentStage.ManageRecurring : NewAppointmentStage.SelectNewSingleAppointment;
  }
  var needSelectParticipants = (0, _lodash.isEmpty)(targetPatient) || (0, _lodash.isEmpty)(targetClinician);
  if (needSelectParticipants) {
    return NewAppointmentStage.SelectParticipants;
  }
  // If clinician is scheduling new appointment
  // through a specific patient's patient details page
  if ((0, _utils.isPhysician)(targetClinician)) {
    return NewAppointmentStage.SelectSingleAppointment;
  }
  if ((0, _utils.isTherapist)(targetClinician)) {
    return (0, _lodash.isEmpty)(recurringRule) ? NewAppointmentStage.SelectAppointmentType :
    // If patient already has a recurring appointment,
    // therapist can still book a one-off appointment
    NewAppointmentStage.SelectSingleAppointment;
  }
  throw new Error('Could not calculate initial stage');
};
var ManagerAppointmentCubbyContextProvider = function ManagerAppointmentCubbyContextProvider(_ref2) {
  var children = _ref2.children,
    targetPatient = _ref2.targetPatient,
    targetClinician = _ref2.targetClinician,
    appointment = _ref2.appointment,
    onCancel = _ref2.onCancel,
    onSuccess = _ref2.onSuccess;
  var _useState = (0, _react.useState)(targetPatient || {}),
    _useState2 = _slicedToArray(_useState, 2),
    patient = _useState2[0],
    setPatient = _useState2[1];
  var _useState3 = (0, _react.useState)(targetClinician || {}),
    _useState4 = _slicedToArray(_useState3, 2),
    clinician = _useState4[0],
    setClinician = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    appointmentScheduled = _useState6[0],
    setAppointmentScheduled = _useState6[1];
  var recurringRule = (0, _utils2.getRecurringRuleFromProps)({
    appointment: appointment,
    patient: patient
  });
  var handleSetParticipants = function handleSetParticipants(lifecyle, context, payload) {
    if (!(0, _lodash.isEmpty)(payload.selectedPatient)) {
      setPatient(payload.selectedPatient);
    }
    if (!(0, _lodash.isEmpty)(payload.selectedClinician)) {
      setClinician(payload.selectedClinician);
    }
  };
  var _useStateMachine = (0, _utils.useStateMachine)({
      initialStage: getInitialStage({
        appointment: appointment,
        targetClinician: targetClinician,
        targetPatient: targetPatient,
        recurringRule: recurringRule
      }),
      transitions: [{
        name: 'bookSingle',
        from: [NewAppointmentStage.SelectParticipants, NewAppointmentStage.SelectAppointmentType],
        to: NewAppointmentStage.SelectSingleAppointment
      }, {
        name: 'bookRecurring',
        from: [NewAppointmentStage.SelectParticipants, NewAppointmentStage.SelectAppointmentType],
        to: NewAppointmentStage.SelectRecurringAppointment
      }, {
        name: 'rescheduleAll',
        from: NewAppointmentStage.ManageRecurring,
        to: NewAppointmentStage.SelectNewRecurringAppointment
      }, {
        name: 'rescheduleOne',
        from: NewAppointmentStage.ManageRecurring,
        to: NewAppointmentStage.SelectNewSingleAppointment
      }, {
        name: 'newSuccess',
        from: [NewAppointmentStage.SelectSingleAppointment, NewAppointmentStage.SelectRecurringAppointment],
        // Return same stage so that cubby is not empty after appointment request
        to: function to() {
          return this.state;
        }
      }, {
        name: 'rescheduleSuccess',
        from: [NewAppointmentStage.SelectNewSingleAppointment, NewAppointmentStage.SelectNewRecurringAppointment],
        // Return same stage so that cubby is not empty after appointment request
        to: function to() {
          return this.state;
        }
      }, {
        name: 'cancel',
        from: '*',
        to: NewAppointmentStage.Finished
      }, {
        name: 'back',
        from: '*',
        to: function to() {
          // If there is no prevoius stage, close the cubby
          return previousStage || NewAppointmentStage.Finished;
        }
      }],
      methods: {
        onBookSingle: handleSetParticipants,
        onBookRecurring: handleSetParticipants,
        onRescheduleAll: handleSetParticipants,
        onNewSuccess: function onNewSuccess() {
          // Cubby closing immediately is visually jarring
          // set a timeout for closing the cubby
          setTimeout(onSuccess, _utils.SHOW_MODAL_SUCCESS_DURATION);
          // set a boolean flag to disable any CTAs once the
          // appointment has been successfully created
          setAppointmentScheduled(true);
          _utils.toast.success({
            title: 'Appointment successfully scheduled!'
          });
        },
        onRescheduleSuccess: function onRescheduleSuccess() {
          // Cubby closing immediately is visually jarring
          // set a timeout for closing the cubby
          setTimeout(onSuccess, _utils.SHOW_MODAL_SUCCESS_DURATION);
          // set a boolean flag to disable any CTAs once the
          // appointment has been successfully created
          setAppointmentScheduled(true);
          _utils.toast.success({
            title: 'Appointment successfully rescheduled!'
          });
        },
        onCancel: onCancel,
        onBack: function onBack() {
          return !previousStage && onCancel();
        }
      }
    }),
    transition = _useStateMachine.transition,
    stage = _useStateMachine.stage,
    previousStage = _useStateMachine.previousStage;
  return /*#__PURE__*/_react.default.createElement(ManagerAppointmentCubbyContext.Provider, {
    value: {
      transition: transition,
      stage: stage,
      patient: patient,
      clinician: clinician,
      appointment: appointment,
      appointmentScheduled: appointmentScheduled,
      targetPatient: targetPatient,
      targetClinician: targetClinician,
      previousStage: previousStage
    }
  }, children);
};
exports.ManagerAppointmentCubbyContextProvider = ManagerAppointmentCubbyContextProvider;